import { memo } from 'react';

function TrailerSwap(props) {
  const { color = '#666666', size = 14 } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="none" viewBox="0 0 14 14">
      <mask
        id="mask0_2831_15"
        width={size}
        height={size}
        x="0"
        y="0"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'luminance' }}>
        <path fill="#fff" d="M14 0H0v14h14z"></path>
      </mask>
      <g mask="url(#mask0_2831_15)">
        <path
          fill={color}
          fillRule="evenodd"
          d="M.402.403A.53.53 0 0 1 .776.248h6v4.368h1.47v1.059H3.628a1.179 1.179 0 0 1-2.282 0h-1.1V.777A.53.53 0 0 1 .402.403m2.984 4.213a1.176 1.176 0 0 0-1.795 0h-.286v-3.31l4.413.001v3.31zM2.23 5.675a.39.39 0 0 0 .516 0 .391.391 0 1 0-.516 0m3.68 1.922a.53.53 0 0 1 .374-.155h6v4.368h1.47v1.059H9.137a1.179 1.179 0 0 1-2.283 0h-1.1V7.97a.53.53 0 0 1 .155-.374m2.984 4.213a1.176 1.176 0 0 0-1.795 0h-.286V8.5h4.413v3.31zm-1.156 1.059a.39.39 0 0 0 .516 0 .39.39 0 0 0-.258-.687.392.392 0 0 0-.258.687M10.728.248 8.636 2.21l2.094 1.963V2.744h1.522v2.95h1.068V1.677h-2.59zM4.932 10.925l-2.094 1.962V11.46H.247V7.442h1.067v2.95h1.523v-1.43z"
          clipRule="evenodd"></path>
      </g>
    </svg>
  );
}

export default memo(TrailerSwap);
